import { Box } from '@hivebrite/design-system/Box';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

export const EventLoading = () => (
  <Box>
    <Box flexDirection="column" alignItems="center">
      <Skeleton width="26px" />
      <Skeleton width="42px" height="42px" mt="5px" />
    </Box>
    <Skeleton height={78} width={148} ml={4} mr={3} />
    <Box
      flex={1}
      flexDirection="row"
      alignItems="flex-start"
      justifyContent="space-between"
      width="100%"
    >
      <Box
        height="100%"
        width="100%"
        flexDirection="column"
        justifyContent="center"
      >
        <Skeleton width="45%" />
        <Skeleton width="60%" mt={2} />
        <Skeleton width="30%" mt={4} />
      </Box>
    </Box>
  </Box>
);
